import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FreshReworkBarChart from "examples/Charts/BarCharts/FreshReworkBarChart";
import ActivityEfficiencyBarChart from "examples/Charts/BarCharts/ActivityEfficiencyBarChart";
import WaitingHoursBarChart from "examples/Charts/BarCharts/WaitingHoursBarChart";
import { ieDashboardData } from "actions/dashboard";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShiftList } from "actions/shift";
import MDButton from "components/MDButton";
import { Card, Grid, TextField, Autocomplete, Icon } from "@mui/material";
import { useNotify } from "components/CommonComponent/NotificationProvider";
import { getProductList } from "actions/product";
import { getUnitListing } from "actions/unit";
import { getProjectList } from "actions/project";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DATE_RANGE_OPTIONS } from "components/common/constant";
import Typography from "@mui/material/Typography";
import { autoCompleteProps } from "components/CommonComponent/CommonFunction";
import { getDepartmentList } from "actions/department";

function IEDashboard() {
  const { notify } = useNotify();
  const dispatch = useDispatch();
  const [efficiencyChartData, setEfficiencyChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Efficiency %",
        backgroundColor: "#156082",
        data: [],
      },
    ],
  });
  const [utilizationChartData, setUtilizationChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [stationUtilisationData, setStationUtilisationData] = useState({
    labels: [],
    datasets: [],
  });
  const [filters, setFilters] = useState(() => {
    const endDate = new Date();
    const startDate = new Date();

    return {
      dateRange: "TODAY",
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      shiftIDs: [],
      typeOfProduct: null,
      unitID: null,
      projectID: null,
      departmentID: null,
      isSearched: false,
    };
  });
  const [listState, setListState] = useState({
    showLoaderOnClick: false,
  });
  const [subActivityHoursChartData, setSubActivityHoursChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [appliedDateRange, setAppliedDateRange] = useState({
    startDate: filters.startDate,
    endDate: filters.endDate,
  });

  const shiftListData = useSelector((state) => state.shift.shiftList);

  const productListData = useSelector((state) => state.product.productList);

  const unitListingData = useSelector((state) => state.unit.unitList);

  const projectListData = useSelector((state) => state.project.projectList);

  const departmentListData = useSelector(
    (state) => state.department.departmentList,
  );

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    getShiftList(dispatch);
    getProductList(dispatch);
    getUnitListing(dispatch);
    getProjectList(dispatch);
    getDepartmentList(dispatch);
  }, [dispatch]);

  const departmentOptions =
    departmentListData?.data?.Department?.map((item) => ({
      id: item.ID,
      name: item.name,
    })) || [];

  const getDateRange = (days) => {
    const today = new Date();

    if (days === "TODAY") {
      const todayString = dayjs(today).format("YYYY-MM-DD");

      return {
        startDate: todayString,
        endDate: todayString,
      };
    }

    const endDate = new Date(today);
    endDate.setDate(endDate.getDate() - 1);

    if (days === "1") {
      const yesterdayString = dayjs(endDate).format("YYYY-MM-DD");

      return {
        startDate: yesterdayString,
        endDate: yesterdayString,
      };
    }

    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - (Number(days) - 1));

    return {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    };
  };

  const shiftOptions =
    shiftListData?.data?.shift?.map((item) => ({
      id: item.ID,
      name: item.name,
    })) || [];

  const productOptions =
    productListData?.data?.Product?.map((item) => ({
      id: item.ID,
      name: item.type,
    })) || [];

  const unitOptions =
    unitListingData?.data?.Unit?.map((item) => ({
      id: item.ID,
      name: item.unitNo,
    })) || [];

  const projectOptions =
    projectListData?.data?.project?.map((item) => ({
      id: item.ID,
      name: item.projectNo,
    })) || [];

  const getDashboardData = async (customPayload = null) => {
    try {
      setListState((prev) => ({
        ...prev,
        showLoaderOnClick: true,
      }));

      const payload = customPayload || {
        startDate: filters.startDate,
        endDate: filters.endDate,
        productTypeID: filters.typeOfProduct ? [filters.typeOfProduct] : [],
        shiftID: filters.shiftIDs,
        unitID: filters.unitID ? [filters.unitID] : [],
        projectID: filters.projectID ? [filters.projectID] : [],
        departmentID: filters.departmentID ? [filters.departmentID] : [],
      };

      const response = await ieDashboardData(payload);

      if (response?.code !== 200) {
        notify(
          Array.isArray(response?.message)
            ? response.message.map((e) => e.Msg).join(", ")
            : response?.message,
          "error",
        );
        return;
      }

      const subActivityHoursData =
        response?.data?.sub_activity_hours_report || [];

      setSubActivityHoursChartData({
        labels: subActivityHoursData.map((item) => item.sub_activity_name),
        datasets: [
          {
            label: "Hours",
            backgroundColor: "#156082",
            data: subActivityHoursData.map((item) => Number(item.hours)),
          },
        ],
      });

      const utilizationData = response?.data?.utilization_report || [];

      setUtilizationChartData({
        labels: utilizationData.map((item) => item.department_name),
        datasets: [
          {
            label: "DIRECT",
            backgroundColor: "#156082",
            data: utilizationData.map((item) => Number(item.direct)),
          },
          {
            label: "INDIRECT",
            backgroundColor: "#ED7D31",
            data: utilizationData.map((item) => Number(item.indirect)),
          },
          {
            label: "IDLE",
            backgroundColor: "#2E7D32",
            data: utilizationData.map((item) => Number(item.idle)),
          },
          {
            label: "WAITING",
            backgroundColor: "#29B6F6",
            data: utilizationData.map((item) => Number(item.waiting)),
          },
        ],
      });

      const stationData = response?.data?.station_utilisation_report || [];

      setStationUtilisationData({
        labels: stationData.map((item) => item.department_name),
        datasets: [
          {
            label: "Active Stations",
            backgroundColor: "#156082",
            data: stationData.map((item) => Number(item.active_stations)),
          },
          {
            label: "Utilized Stations",
            backgroundColor: "#ED7D31",
            data: stationData.map((item) => Number(item.utilized_stations)),
          },
        ],
      });

      const efficiencyData = response?.data?.efficiency_report || [];

      setEfficiencyChartData({
        labels: efficiencyData.map((item) => item.department_name),
        datasets: [
          {
            label: "Efficiency %",
            backgroundColor: "#156082",
            data: efficiencyData.map((item) => Number(item.efficiency_rate)),
          },
        ],
      });
    } catch (error) {
      notify(error?.message || "Something went wrong", "error");
    } finally {
      setListState((prev) => ({
        ...prev,
        showLoaderOnClick: false,
      }));
    }
  };

  const handleSearch = () => {
    setAppliedDateRange({
      startDate: filters.startDate,
      endDate: filters.endDate,
    });

    getDashboardData();

    setFilters((prev) => ({
      ...prev,
      isSearched: true,
    }));
  };

  const handleClear = () => {
    const endDate = new Date();
    const startDate = new Date();

    const resetFilters = {
      dateRange: "TODAY",
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      shiftIDs: [],
      typeOfProduct: null,
      unitID: null,
      projectID: null,
      isSearched: false,
    };

    setAppliedDateRange({
      startDate: resetFilters.startDate,
      endDate: resetFilters.endDate,
    });

    setFilters(resetFilters);

    getDashboardData({
      startDate: resetFilters.startDate,
      endDate: resetFilters.endDate,
      shiftIDs: [],
      unitID: null,
      productID: null,
      projectID: null,
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={DATE_RANGE_OPTIONS}
                      value={
                        DATE_RANGE_OPTIONS.find(
                          (item) => item.value === filters.dateRange,
                        ) || null
                      }
                      getOptionLabel={(option) => option.label}
                      onChange={(event, value) => {
                        if (!value) return;

                        if (value.value === "CUSTOM") {
                          setFilters({
                            ...filters,
                            dateRange: "CUSTOM",
                          });
                        } else {
                          const dates = getDateRange(value.value);

                          setFilters({
                            ...filters,
                            dateRange: value.value,
                            startDate: dates.startDate,
                            endDate: dates.endDate,
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Date Range"
                        />
                      )}
                    />
                  </Grid>
                  {filters.dateRange === "CUSTOM" && (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            disableFuture
                            label="Start Date"
                            value={dayjs(filters.startDate)}
                            onChange={(value) =>
                              setFilters((prev) => ({
                                ...prev,
                                startDate: value?.format("YYYY-MM-DD") || "",
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            disableFuture
                            label="End Date"
                            minDate={dayjs(filters.startDate)}
                            value={dayjs(filters.endDate)}
                            onChange={(value) =>
                              setFilters((prev) => ({
                                ...prev,
                                endDate: value?.format("YYYY-MM-DD") || "",
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={departmentOptions}
                      value={
                        departmentOptions.find(
                          (item) => item.id === filters.departmentID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          departmentID: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Department"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={shiftOptions}
                      value={
                        shiftOptions.find(
                          (item) => item.id === filters.shiftIDs?.[0],
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          shiftIDs: value ? [value.id] : [],
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Shift" />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={productOptions}
                      value={
                        productOptions.find(
                          (item) => item.name === filters.typeOfProduct,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          typeOfProduct: value?.name || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Product Type"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={unitOptions}
                      value={
                        unitOptions.find(
                          (item) => item.id === filters.unitID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          unitID: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Unit" />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={projectOptions}
                      value={
                        projectOptions.find(
                          (item) => item.id === filters.projectID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          projectID: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Project Number"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg="auto">
                    <MDBox
                      display="flex"
                      flexDirection="row"
                      gap={1}
                      width="100%"
                    >
                      <MDButton
                        variant="contained"
                        color="deepBlue"
                        sx={{
                          minWidth: "120px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={handleSearch}
                        disabled={listState.showLoaderOnClick}
                      >
                        {listState.showLoaderOnClick ? (
                          <i className="fa fa-spinner fa-spin fa-lg text-white" />
                        ) : (
                          <>
                            <Icon sx={{ mr: 1 }}>search</Icon>
                            Search
                          </>
                        )}
                      </MDButton>

                      {filters.isSearched && (
                        <MDButton
                          variant="contained"
                          color="deepBlue"
                          sx={{
                            minWidth: "120px",
                            whiteSpace: "nowrap",
                          }}
                          onClick={handleClear}
                        >
                          <Icon sx={{ mr: 1 }}>close</Icon>
                          Clear
                        </MDButton>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3} mt={0.3}>
          <Grid item xs={4}>
            <Card>
              <MDBox px={3} py={1.5}>
                <Typography variant="body2" fontWeight="bold">
                  {
                    DATE_RANGE_OPTIONS.find(
                      (item) => item.value === filters.dateRange,
                    )?.label
                  }
                </Typography>

                <Typography variant="caption" color="text">
                  {appliedDateRange.startDate === appliedDateRange.endDate
                    ? dayjs(appliedDateRange.startDate).format("DD-MMM-YYYY")
                    : `${dayjs(appliedDateRange.startDate).format("DD-MMM-YYYY")} to ${dayjs(
                        appliedDateRange.endDate,
                      ).format("DD-MMM-YYYY")}`}
                </Typography>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <MDBox mt={4.5}></MDBox>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox mb={3}>
                  <FreshReworkBarChart
                    color="light"
                    title="Utilization Report"
                    description=""
                    date=""
                    chart={utilizationChartData}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox mb={3}>
                  <FreshReworkBarChart
                    color="light"
                    title="Station Utilization Report"
                    description=""
                    date=""
                    chart={stationUtilisationData}
                  />
                </MDBox>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <ActivityEfficiencyBarChart
                  color="light"
                  title="Efficiency %"
                  description=""
                  date=""
                  chart={efficiencyChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <WaitingHoursBarChart
                  color="light"
                  title="Sub-Activity wise Hours Allocation"
                  description=""
                  date=""
                  chart={subActivityHoursChartData}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default IEDashboard;
